import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EditHistoryModule } from "src/app/core/edit-history/edit-history.module";
import { DynamicFormModule } from "src/app/core/dynamic-form/dynamic-form.module";
import { ClientDto, CreateClient, UpdateClient } from '../clienti';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidatorService } from 'angular-iban';
import _ from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import { DynamicFormComponent } from 'src/app/core/dynamic-form/dynamic-form.component';
import { DynamicFormOptions, FieldConfig, FieldTypeEnum } from 'src/app/core/dynamic-form/dynamicForm.interface';
import { EditHistoryData } from 'src/app/core/edit-history/edit-history';
import { ToastService } from 'src/app/core/toast/toast.service';
import { environment } from 'src/environments/environment';
import { ClientiService } from '../clienti.service';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { customBreadCrumbRequest } from 'src/app/core/bread-crumbs/bread-crumbs.component';

@Component({
  selector: 'app-clienti-form',
  imports: [CommonModule, EditHistoryModule, DynamicFormModule],
  templateUrl: './clienti-form.component.html',
  styleUrl: './clienti-form.component.scss'
})
export class ClientiFormComponent implements OnInit, OnDestroy {
  @ViewChild('myForm') myForm!: DynamicFormComponent;

  //DATA FROM API, THE ONE THAT GETS CHANGED AND THE OG ONE 
  //CHANGE THE TYPE TO THE ONE YOU NEED
  public object?: ClientDto;

  //ID
  codice: string = '';

  //FORM OPTIONS, DEFINED IN CONSTRUCTOR
  form2Opts: DynamicFormOptions;

  //FOR SHOWING OR HIDING FORM, USEFULL FOR REINITIALIZING
  ready: boolean = false;

  //FOR SHOWING CREATEDBY AND EDITEDBY
  editHistoryData: EditHistoryData | undefined

  //FORM FIELDS
  regConfig2: FieldConfig[] = [];


  //NO MEMORY LEAKS FIX 
  private theEnd$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute, //IF YOU USE paramMap
    private router: Router,
    private toast: ToastService,
    private clientiService: ClientiService,
    private localStorageService: LocalStorageService
  ) {

    this.form2Opts = {
      buttonAtBottom: true, //PUT THIS ALWAYS TO MAKE BUTTON STICK TO BOTTOM
      formType: 'add', //add, edit, view
      editOptions: {
        entityName: 'cliente', //for lockserver apis
        entityDisplayName: 'Cliente', //placeholder for messages
        deleteUrl: `${environment.apiUrl}/clients`, //delete url
        deleteMessage: `Stai per eliminare il cliente, procedere?`, //message on delete dialog
        deleteItem: '', //delete code/id depends, assign this when initializing form
        entityId: '', //id for lockserver apis
        isFem: false, //is fem or male?
        redirectUrl: `home/clienti` //url where it goes after delete
      },
      addOptions: {
        entityName: 'cliente',
        entityDisplayName: 'Cliente',
        isFem: false,
        redirectUrl: `home/clienti`//url where it goes when cancelling
      }
    };
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  ngOnInit(): void {


    this.initializeForm();

  }


  //based on route decides what form to show, adapt this logic if url contains more add or edit strings
  initializeForm() {



    if (this.router.url.includes('new')) {
      this.form2Opts.formType = 'add'
      this.localStorageService.setTitolo('Nuovo cliente');
      this.initializeFormFields();
    } else {

      this.form2Opts.formType = 'edit'
      this.initializeEditForm();
    }







  }

  initializeFormFields() {

    this.regConfig2 = [
      {
        type: FieldTypeEnum.input,
        name: 'name',
        label: 'Nome',
        isRequired: true,
        width: 'w-1/2',
        value: this.object ? this.object.name : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci un nome',
          },
        ],
      },
      {
        type: FieldTypeEnum.input,
        name: 'description',
        label: 'Descrizione',
        isRequired: true,
        width: 'w-1/2',
        value: this.object ? this.object.description : undefined,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Inserisci una descrizione',
          },
        ],
      },
    ]

    this.ready = true;

  }


  //make api call and get data for edit
  initializeEditForm() {
    this.codice = this.route.snapshot.paramMap.get('id') || '';

    this.clientiService.read(this.codice).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (response: ClientDto) => {
        this.object = _.cloneDeep(response);
        this.localStorageService.setTitolo(`Modifica cliente ${response.name}`);

        let req: customBreadCrumbRequest = {
            oldString: response.id,
            newString: response.name,
          }
          this.localStorageService.setCustomBreadCrumb(req);

        if (this.form2Opts.editOptions) {
          this.form2Opts.editOptions.deleteItem = '' + this.object.id;
          this.form2Opts.editOptions.entityId = this.object.id;
        }

        //run this method to display form
        this.initializeFormFields();

      },
      error: () => {

      }
    });


  }


  //fires when submitting
  submit(event: any) {
    if (this.form2Opts.formType == 'add') {
      this.add(event);
    } else {
      this.edit(event);
    }
  }

  //edit submit
  edit(event: any) {
    console.log(event)
    let data: UpdateClient = {
      name: event.name,
      description: event.description
    }

    this.clientiService.update(this.codice, data).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (response: ClientDto) => {
        this.toast.success('Modifiche salvate')
      },
      error: () => {

      }
    })
  }

  //add submit
  add(event: any) {
    console.log(event)
    let data: CreateClient = {
      name: event.name,
      description: event.description
    }

    this.clientiService.create(data).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (response: ClientDto) => {
        this.toast.success('Cliente creato')
        this.router.navigate(['home/clienti', response.id])
      },
      error: () => {

      }
    })
  }
}
